             

                                                                        

import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
	rus: (
		`
		
    <div style="text-align: justify;">
		
			<p class="text-end epigraf mb-5">
				Приезжает большой начальник в город <br/>
				и местные власти ему отчитываются: <br/>
				«Масла нет – народ не ропщет; <br/>
				горячей воды нет – народ не ропщет; <br/>
				городской транспорт не ходит – не ропщут!». <br/>
				И тут из зала подсказка: <br/>
				«А дустом не пробовали?»  
			</p>
			
			<p class="mb-3">
				Первой серией был к-в. 
				Два года шло… уж как нагнетали, как нагнетали! 
				Дружно, по всему миру под копирку! 
				Хотя, правда, почему по всему миру? 
				Где новости из Азии, Африки, Лат. Америки? 
				Там, где низкий уровень жизни, бытовая грязь и отсутствие медицины? – 
				“Да кто их считает, этих цветных! Кого они интересуют??” 
				– Уж точно не Европу! 
			</p>
			
			<p class="mb-3">
				Она-то думает только о себе. 
				И даже как-то забыла, что есть другие части света… 
				Грубовато подаёт информацию; но пипл схавает, а другие части света нам и даром не нужны: только Европа + США, 
				да ещё пару США-вок типа Канады да Австралии. 
				Бедные государства никого не интересуют, они в любом случае будут под властью богатых; а вот богатые-то нам и нужны!
			</p>
			
			<p class="mb-3">
				Первый этап – «пандемия»: захват власти над миром (богатым миром!:-). 
				Разрушение экономики, обрыв всяческих связей: между государствами, между городами, между людьми. 
				Эти связи заменяются искусственными: человеческое общение заменяется компьютерным, что приносит невероятные прибыли ИТ-индустрии; 
				точнее, тем, кто управляет некоторыми её ветвями. 
				Такие же прибыли получает фармацевтическая промышленность, быстренько сварганив вакцины (но не лекарства!) от выведенной «болезни». 
				Ведь лекарства нужно давать только больным, а вакцину – всем!
			</p>
			
			<p class="mb-3">
				Болезнь специально сделана тяжёлой (чтоб запугать и принудить к вакцинации), но не смертельной: 
				зачем же паразиту уничтожать своего хозяина?? 
				Уничтожала она только генетический и социальный груз: стариков и больных, не нужных в новом обществе. 
			</p>
			
			<p class="mb-3">
				Шёл тяжёлый прессинг: 60-70% всей новостной информации посвящалось теме к-в; она красным шрифтом выделялась во всех странах. 
				Людей запугивали и ввергали в безумие, обрушивая на них лавину информации, не давая задуматься, остановиться; 
				а изоляция мешала простому человеческому общению и взаимоподдержке. 
				Люди стали безумны и разъединены; а всем давно известно, что «pueblo unido jamas sera vencido», 
				так что убивать народ легче всего поодиночке. 
				Такой же жестокий прессинг давил все несогласные голоса; а то, о чём не говорят и не пишут СМИ, для людей просто не существует.
			</p>
			
			<p class="mb-3">
				Но прошло два года, и люди стали уже как-то привыкать и перестали бояться. 
				«…демия» исчерпала себя, а человечество ещё не покорено! 
				И даже начинает оправляться, кто может – думать, и даже говорить и делать, сбрасывая с себя наложенные путы. 
				“Нет, так дело не пойдёт! Приступаем к плану Б, второй серии чётко расписанного представления. 
				Не взяла вас болезнь? – Вот средство похлеще: война! 
				Тут уж вас поубивают наверняка, и экономика, и жизненные условия развалятся не виртуально, на бумаге, 
				а прямо на ваших глазах и в ваших жизнях! 
				Мы стали богаче, мы стали сильнее, и мы всё равно освободим Землю от лишнего, ненужного нам населения! 
				Не мытьём, так ка́таньем! 
				Не хотели от болезней – сдохнете от ракет!”. 
				План Б приводится в исполнение.
			</p>
			
			<p class="mb-3">
				Неужели кому-то неясно, что это началась III Мировая война, и она не окончится через пару недель?! 
				Не пересидим мы в подвалах, не спасутся те, кто удирали в другие страны Европки. 
				Таки-да, останется на Земле один золотой миллиард. 
				И его хозяева. 
			</p>

		</div>
		`
	)
}

const itemName = {
	rus: `Весна 2020 - вторая серия`
}

const itemDate = {
	rus: `1 марта 2022 года`
}

const item = {
	itemlink: getLink(itemName.rus),
	rus: {
		itemName: itemName.rus,
		itemContent: content.rus,
		itemDate: itemDate.rus,
		itemAuthor: author.rus
	}
}

export default item;